<template>
  <div>
    <v-container container--fluid grid-list-xl>
      <v-row align="center">
        <v-col cols="12" md="5":class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h1>Search Deliveries (Mass Actions)</h1>
        </v-col>
        <v-col cols="12" md="4">
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn icon color="blue darken-1" @click="uploadDialog=true" v-on="on" v-show="viewPermission">
                <v-icon>cloud_upload</v-icon>
              </v-btn>
            </template>
            <span>Upload your changes</span>
          </v-tooltip>
        </v-col>

      </v-row>

      <v-card color="#42424211">

        <v-card-title>Mandatory Fields</v-card-title>
        <v-container>
          <v-row align="center" justify="space-around" class="my-0" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
            <v-col cols="12" md="4">
              <v-autocomplete
                label="Select a Region"
                v-model="region"
                :items="regions"
                item-text="name"
                item-value="id"
                prepend-inner-icon="fas fa-map"
                background-color="white"
                auto-select-first
                outlined
                :menu-props="{transition: 'slide-x-transition'}"
                @input="newSearch"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <DatePicker
                ref="date"
                label="Select a Date"
                prepend-inner-icon="fas fa-calendar"
                :special-style="true"
                :date_props="date"
                @interface="(event) => {date = event; newSearch()} "
              ></DatePicker>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-expansion-panels>
          <v-expansion-panel style="background-color: #00000000" :disabled="disableFilter">
            <v-expansion-panel-header v-slot="{ open }">
              <v-card-title class="pa-0">Filter</v-card-title>
<!--              <v-sheet class="py-4 px-1">-->
<!--                <v-chip-group-->
<!--                  multiple-->
<!--                  active-class="primary&#45;&#45;text"-->
<!--                >-->
<!--                  <v-chip></v-chip>-->
<!--                </v-chip-group>-->
<!--              </v-sheet>-->
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card class="mx-2" outlined color="#4242420e" :disabled="loading">
                <v-container>
                  <v-row justify="space-around">
                    <v-col cols="11" md="3" class="ma-2">
                      <v-autocomplete
                        label="Select a Depot"
                        v-model="searchFilter.depot_id"
                        :items="searchFilterList.depot.list"
                        item-text="name"
                        item-value="id"
                        prepend-icon="fas fa-warehouse"
                        auto-select-first dense clearable
                        :menu-props="{transition: 'slide-x-transition'}"
                      ></v-autocomplete>
                    </v-col>
                    <v-divider class="mx-4" vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
                    <v-col cols="11" md="3" class="ma-2">
                      <v-autocomplete
                        label="Select a Client"
                        v-model="searchFilter.client_id"
                        :items="searchFilterList.client.list"
                        item-text="name"
                        item-value="id"
                        prepend-icon="fas fa-user"
                        auto-select-first dense clearable
                        :menu-props="{transition: 'slide-x-transition'}"
                      ></v-autocomplete>
                    </v-col>
                    <v-divider class="mx-4" vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
                    <v-col cols="11" md="3" class="ma-2">
                      <v-autocomplete
                        label="Select a Zone"
                        v-model="searchFilter.zone_id"
                        :items="searchFilterList.zone.list"
                        item-text="name"
                        item-value="id"
                        prepend-icon="fas fa-map-pin"
                        auto-select-first dense clearable
                        :menu-props="{transition: 'slide-x-transition'}"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row justify="space-around">
                    <v-col cols="11" md="3" class="ma-2">
                      <v-autocomplete
                        label="Select a Service"
                        v-model="searchFilter.service_id"
                        :items="searchFilterList.service.list"
                        item-text="name"
                        item-value="id"
                        prepend-icon="fas fa-concierge-bell"
                        auto-select-first dense clearable
                        :menu-props="{transition: 'slide-x-transition'}"
                      ></v-autocomplete>
                    </v-col>
                    <v-divider class="mx-4" vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
                    <v-col cols="11" md="3" class="ma-2">
                      <v-autocomplete
                        label="Route Name"
                        v-model="searchFilter.route_name"
                        :items="searchFilterList.route_name.list"
                        item-text="name"
                        item-value="id"
                        prepend-icon="fas fa-road"
                        auto-select-first dense clearable
                        :menu-props="{transition: 'slide-x-transition'}"
                      ></v-autocomplete>
                    </v-col>
                    <v-divider class="mx-4" vertical v-if="$vuetify.breakpoint.mdAndUp && searchFilterList.reason_code.idList[0]"></v-divider>
                    <v-col cols="11" md="3" class="ma-2" v-if="searchFilterList.reason_code.idList[0]">
                      <v-row align="center" :class="$vuetify.breakpoint.xs ? 'column justify-center': ''">
                        <v-col cols="4" :class="$vuetify.breakpoint.xs ? ' py-0': ''">
                          <v-subheader :class="$vuetify.breakpoint.xs ? 'text-center px-0': 'text-left'">
                            Reason Code:
                          </v-subheader>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-chip-group v-model="searchFilter.reason_code" active-class="primary--text">
                            <v-chip v-for="item in searchFilterList.reason_code.list" :key="item.id" :value="item.id">
                              {{ item.name }}
                            </v-chip>
                          </v-chip-group>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row justify="space-around">
                    <v-col cols="11" md="5" class="mx-2">
                      <v-row align="center" :class="$vuetify.breakpoint.xs ? 'column justify-center': ''">
                        <v-col cols="3" class="pa-0">
                          <v-subheader :class="$vuetify.breakpoint.xs ? 'text-center pa-0': 'text-left pa-0'">
                            Status:
                          </v-subheader>
                        </v-col>
                        <v-col cols="12" md="9" class="pa-0">
                          <v-chip-group v-model="searchFilter.status" active-class="primary--text">
                            <v-chip v-for="item in searchFilterList.status.list" :key="item.id" :value="item.id">
                              {{ item.name }}
                            </v-chip>
                          </v-chip-group>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-divider class="mx-4" vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
                    <v-col cols="11" md="5" class="mx-2">
                      <v-row align="center" :class="$vuetify.breakpoint.xs ? 'column justify-center': ''">
                        <v-col cols="3" class="pa-0">
                          <v-subheader :class="$vuetify.breakpoint.xs ? 'text-center pa-0': 'text-left pa-0'">
                            Routing Rule:
                          </v-subheader>
                        </v-col>
                        <v-col cols="12" md="9" class="pa-0">
                          <v-chip-group v-model="searchFilter.routing_rule" active-class="primary--text">
                            <v-chip v-for="item in searchFilterList.routing_rule.list" :key="item.id" :value="item.id">
                              {{ item.name }}
                            </v-chip>
                          </v-chip-group>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
              <v-row justify="center" class="mt-10">
                <v-col md="3" sm="12" cols="12">
                  <v-btn text block color="blue-grey lighten-2" @click="clearFields">Clear</v-btn>
                </v-col>
                <v-col md="3" sm="12" cols="12">
                  <v-btn text outlined block color="indigo" @click="updateTable">Search</v-btn>
                </v-col>
                <v-col md="3" sm="12" cols="12">
                  <v-btn text outlined block color="indigo" @click="downloadCSV">Download</v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>


      </v-card>

      <v-spacer></v-spacer>

      <v-container>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="renderedSearch"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Search Table</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>

        <v-spacer></v-spacer>

        <v-row justify="space-around">
          <v-col cols="12" md="3">
            <v-btn
              @click="rescheduleDialog=true"
              block primary
              color="#1357a4"
              style="color:#FFFFFF"
              :disabled="disableFilter || loading"
            >
              Reschedule All
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              @click="cancelDialog=true"
              block primary
              color="error"
              :disabled="disableFilter || loading"
            >
              Cancel All
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              @click="deleteDialog=true"
              block primary
              color="grey"
              :disabled="disableFilter || loading"
            >
              Delete All
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              @click="flagDialog=true"
              block primary
              color="orange"
              :disabled="disableFilter || loading"
            >
              Flag All
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

    </v-container>

    <v-dialog v-model="deleteDialog" width="800px" persistent>
      <v-card>
        <v-card-title>
          <h2>{{'Delete these ' + renderedSearch.length + ' deliveries ?'}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDeleteDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-container>
            <v-row justify="space-between">
              <v-col cols="6">
                <v-select
                  v-model="deleteItem.reason_code"
                  :items="reasonCodes"
                  item-text="text"
                  item-value="value"
                  label="Reason Code"
                ></v-select>
              </v-col>
              <v-col cols="4" justify="center">
                <v-switch
                  v-model="deleteItem.admin_override"
                  label="Admin override"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12">
                <v-textarea
                  v-model="deleteItem.note"
                  outlined
                >
                  <template v-slot:label>
                    <div>Note <small>(optional)</small></div>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col md="8" sm="12" cols="12">
                <v-btn text outlined block color="indigo" @click="deleteAll">Proceed</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelDialog" width="800px" persistent>
      <v-card>
        <v-card-title>
          <h2>{{'Cancel these ' + renderedSearch.length + ' deliveries ?'}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeCancelDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-container>
            <v-row justify="space-between">
              <v-col cols="6">
                <v-select
                  v-model="cancelItem.reason_code"
                  :items="reasonCodes"
                  item-text="text"
                  item-value="value"
                  label="Reason Code"
                ></v-select>
              </v-col>
              <v-col cols="4" justify="center">
                <v-switch
                  v-model="cancelItem.ignore_cutoff"
                  label="Ignore Cutoff"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12">
                <v-textarea
                  v-model="cancelItem.note"
                  outlined
                >
                  <template v-slot:label>
                    <div>Note <small>(optional)</small></div>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col md="8" sm="12" cols="12">
                <v-btn text outlined block color="indigo" @click="cancelAll">Proceed</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rescheduleDialog" width="800px" persistent>
      <v-card>
        <v-card-title>
          <h2>{{'Reschedule these ' + renderedSearch.length + ' deliveries ?'}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeRescheduleDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-container>
            <v-row justify="space-between">
              <v-col md="4" cols="12">
                <DatePicker
                  ref="rescheduleDate"
                  label="Select a date"
                  prepend-inner-icon="fas fa-calendar"
                  :special-style="false"
                  :date_props="rescheduleItem.date"
                  @interface="(event) => {rescheduleItem.date = event; rescheduleItem.day = weekday[new Date(event).getDay()]} "
                ></DatePicker>
              </v-col>
              <v-col md="6" cols="12">
                <v-select
                  v-model="rescheduleItem.time_window_id"
                  :items="renderedTimeWindows"
                  item-value="id"
                  label="Pick time window"
                  :disabled="!rescheduleItem.date"
                >
                  <template slot="selection" slot-scope="data">
                    {{data.item.day}} : {{ data.item.time_start }} - {{ data.item.time_end }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{data.item.day}} : {{ data.item.time_start }} - {{ data.item.time_end }}
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col md="4" cols="12" justify="center">
                <v-switch
                  v-model="rescheduleItem.ignore_cutoff"
                  label="Ignore Cutoff"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col md="8" sm="12" cols="12">
                <v-btn text outlined block color="indigo" @click="rescheduleAll">Proceed</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="flagDialog" width="800px" persistent>
      <v-card>
        <v-card-title>
          <h2>{{'Flag these ' + renderedSearch.length + ' deliveries ?'}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeFlagDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-container>
            <v-row justify="space-between">
              <v-col cols="6">
                <v-select
                  label="Error Type"
                  :items="errorTypes"
                  item-text="text"
                  v-model="flagItem.errorType"
                  return-object
                  @input="fault = flagItem.errorType.fault"
                ></v-select>
              </v-col>
              <v-col cols="6" v-if="isInternalUser">
                <v-select
                  label="Choose a source error"
                  :items="fault"
                  item-text="text"
                  item-value="value"
                  v-model="flagItem.source"
                  prepend-icon="fas fa-truck"
                  :disabled="!flagItem.errorType"
                ></v-select>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12">
                <v-textarea
                  v-model="flagItem.note"
                  outlined
                >
                  <template v-slot:label>
                    <div>Note <small>(optional)</small></div>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col md="8" sm="12" cols="12">
                <v-btn text outlined block color="indigo" @click="flagAll">Proceed</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="uploadDialog" width="800px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>Upload Production Changes</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="uploadDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" md="4">
              <v-autocomplete
                label="Select a Client"
                v-model="select_client_id"
                :items="renderedClients"
                item-text="name"
                item-value="id"
                prepend-icon="fas fa-user"
                auto-select-first dense clearable
                :menu-props="{transition: 'slide-x-transition'}"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-row align="center" justify="center" class="my-0">
              <v-col cols="12" md="4" class="text-center">
                <v-btn text @click="$refs.csvUpload.click()" color="warning" block>
                  <div v-if="file===''">Select Your Production Changes</div>
                  <div v-else>{{this.file.name}}</div>
                </v-btn>
                <input v-show="false" ref="csvUpload" type="file" @change="handleFileUpload">
              </v-col>
              <v-col cols="12" md="4" class="text-center">
                <v-btn text block color="blue darken-1" @click="submitFile()">
                  <v-icon class="mr-2">cloud_upload</v-icon>
                  UPLOAD
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import DatePicker from "../../parts/DatePicker";

  export default {
    name: "SearchDeliveryActionPage",
    components: {DatePicker},
    data () {
      return {
        region: null,
        date: null,
        searchFilter : {
          depot_id: null,
          client_id: null,
          zone_id: null,
          status: null,
          routing_rule: null,
          route_name: null,
          reason_code: null,
          service_id: null,
        },
        searchFilterList : {
          depot: {id: 'depot_id', name: 'depot_name', list: [], idList: []},
          client: {id: 'client_id', name: 'client_name', list: [], idList: []},
          zone: {id: 'zone_id', name: 'zone_name', list: [], idList: []},
          status: {id: 'status', name: 'status', list: [], idList: []},
          routing_rule: {id: 'routing_rule', name: 'routing_rule', list: [], idList: []},
          route_name: {id: 'route_name', name: 'route_name', list: [], idList: []},
          reason_code: {id: 'reason_code', name: 'reason_code', list: [], idList: []},
          service: {id: 'service_id', name: 'service_name', list: [], idList: []}
        },
        loading: false,
        reload: false,
        searchurl: '',
        searchFilterListUpdate: true,
        disableFilter: true,

        deleteDialog: false,
        deleteItem : {
          reason_code: null,
          note: null,
          admin_override: false
        },

        cancelDialog: false,
        cancelItem : {
          reason_code: null,
          note: null,
          ignore_cutoff: false
        },
        reasonCodes: [
          {value: 'CNX', text: this.$store.getters['fullNameReasonCode']('CNX')},
          {value: 'R', text: this.$store.getters['fullNameReasonCode']('R')},
          {value: 'GNR', text: this.$store.getters['fullNameReasonCode']('GNR')},
          {value: 'DG', text: this.$store.getters['fullNameReasonCode']('DG')},
          {value: 'BC', text: this.$store.getters['fullNameReasonCode']('BC')},
          {value: 'BA', text: this.$store.getters['fullNameReasonCode']('BA')},
          {value: 'A', text: this.$store.getters['fullNameReasonCode']('A')},
          {value: 'I', text: this.$store.getters['fullNameReasonCode']('I')},
          {value: 'B', text: this.$store.getters['fullNameReasonCode']('B')},
          {value: 'DT', text: this.$store.getters['fullNameReasonCode']('DT')},
          {value: 'HO', text: this.$store.getters['fullNameReasonCode']('HO')},
          {value: 'O', text: this.$store.getters['fullNameReasonCode']('O')}
        ],

        rescheduleDialog: false,
        rescheduleItem: {
          date: null,
          day: null,
          time_window_id: null,
          ignore_cutoff: false
        },
        weekday: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],

        flagDialog: false,
        flagItem : {
          errorType: null,
          source: null,
          note: null
        },
        fault: [],
        uploadDialog:false,
        select_client_id:null,
        file: '',
        isLoaded: false,
      }
    },
    methods: {
      getSearchFilterList( searchResponse ) {
        if (this.searchFilterListUpdate){
          for (let idx in searchResponse){
            const delivery = searchResponse[idx];
            for (let key in this.searchFilterList){
              const itemKey = this.searchFilterList[key];
              if ( !itemKey.idList.includes(delivery[itemKey.id]) ){
                itemKey.list.push( {id: delivery[itemKey.id], name: delivery[itemKey.name]} );
                itemKey.idList.push(delivery[itemKey.id]);
              }
            }
          }
          this.searchFilterListUpdate = false;
          this.disableFilter = false;
        }
      },
      getFilterUrl(){
        let searchurl=''
        let index = -1;
        for (let terms in this.searchFilter){
          if (this.searchFilter[terms]){
            index++;
            searchurl = searchurl + '&search_terms['+ index +'][comparison]=='
              + '&search_terms['+ index +'][column]=' + terms
              + '&search_terms['+ index +'][value]=' + this.searchFilter[terms]
          }
        }
        this.searchurl = searchurl;
      },
      clearFields(){
        for (let key in this.searchFilter){
          this.searchFilter[key] = null;
        }
        this.getFilterUrl();
        this.reload = !this.reload;
      },
      updateTable(){
        this.getFilterUrl();
        this.reload = !this.reload;
      },
      newSearch(){
        if( this.region && this.date){
          for (let key in this.searchFilterList){
            this.searchFilterList[key].list = [];
            this.searchFilterList[key].idList = [];
          }
          this.searchFilterListUpdate = true;
          this.reload = !this.reload;
        }
      },
      loopJobEnded(){
        const proceed = () => {
          if (!this.$store.getters['waitDialog']){
            console.log('job done and table updating');
            this.updateTable();
          } else {
            console.log('job still processing...');
            this.loopJobEnded();
          }
        };
        setTimeout(function() {
          proceed();
        }, 2000)
      },

      closeDeleteDialog(){
        this.deleteDialog = false;
        for (let item in this.deleteItem){
          this.deleteItem[item] = null;
        }
      },
      closeCancelDialog(){
        this.cancelDialog = false;
        for (let item in this.cancelItem){
          this.cancelItem[item] = null;
        }
      },
      closeRescheduleDialog(){
        this.rescheduleDialog = false;
        this.$refs.rescheduleDate.clear();
        for (let item in this.rescheduleItem){
          this.rescheduleItem[item] = null;
        }
      },
      closeFlagDialog(){
        this.flagDialog = false;
        this.fault = [];
        for (let item in this.flagItem){
          this.cancelItem[item] = null;
        }
      },
      deleteAll(){
        const urlparams = '?region_id='+this.region+'&date='+this.date;
        return axios.post(process.env.API_URL + '/deliveries/batch/delete' + urlparams + this.searchurl, this.deleteItem)
          .then((response) => {
            this.closeDeleteDialog();
            this.$store.commit('displaySnackbar', 'Delete successfully');
            this.$store.dispatch('displayJobDialog', response.data);
            this.loopJobEnded();
            return response.data;
          })
          .catch((err) => {
            this.$store.commit('displaySnackbar', 'ERROR in cancel deliveries ' + err);
            this.loading = false;
            return [];
          });
      },
      cancelAll(){
        const urlparams = '?region_id='+this.region+'&date='+this.date;
        return axios.post(process.env.API_URL + '/deliveries/batch/cancel' + urlparams + this.searchurl, this.cancelItem)
          .then((response) => {
            this.closeCancelDialog();
            this.$store.commit('displaySnackbar', 'Cancel successfully');
            this.$store.dispatch('displayJobDialog', response.data);
            this.loopJobEnded();
            return response.data;
          })
          .catch((err) => {
            this.$store.commit('displaySnackbar', 'ERROR in cancel deliveries ' + err);
            this.loading = false;
            return [];
          });
        },
      rescheduleAll(){
        const urlparams = '?region_id='+this.region+'&date='+this.date;
        return axios.post(process.env.API_URL + '/deliveries/batch/reschedule' + urlparams + this.searchurl, this.rescheduleItem)
          .then((response) => {
            this.closeRescheduleDialog();
            this.$store.commit('displaySnackbar', 'Reschedule successfully');
            this.$store.dispatch('displayJobDialog', response.data);
            this.loopJobEnded();
            return response.data;
          })
          .catch((err) => {
            this.$store.commit('displaySnackbar', 'ERROR in cancel deliveries ' + err);
            this.loading = false;
            return [];
          });
        },
      flagAll(){
        const urlparams = '?region_id='+this.region+'&date='+this.date;
        const body = {
          code: this.flagItem.errorType.value,
          fault_code: this.flagItem.source,
          note: this.flagItem.note
        };
        return axios.post(process.env.API_URL + '/deliveries/batch/error' + urlparams + this.searchurl, body)
          .then((response) => {
            this.closeFlagDialog();
            this.$store.commit('displaySnackbar', 'Flag error successfully');
            this.$store.dispatch('displayJobDialog', response.data);
            this.loopJobEnded();
            return response.data;
          })
          .catch((err) => {
            this.$store.commit('displaySnackbar', 'ERROR in flag deliveries ' + err);
            this.loading = false;
            return [];
          });
      },
      downloadCSV(){
        const urlparams = '&region_id='+this.region+'&date='+this.date;
        window.open(process.env.API_URL + '/deliveries/search/csv?key=' + encodeURI(this.$store.state.auth.key) + urlparams + this.searchurl, '_blank')
      },
      submitFile(){
        let formData = new FormData();

        if (this.file !== null) {
          formData.set('client_id', this.select_client_id);
          formData.append('csv', this.file);
          axios({
            method: 'post',
            url: process.env.API_URL + '/deliveries/batch/manual',
            data: formData,
            config: {
              headers: {
                'Content-Type':
                  'multipart/form-data'
              }
            }
          })
            .then((response) => {
              this.$store.dispatch('displayJobDialog', response.data);
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', error.response.status);
            })
        } else {
          this.$emit('alert', 'Please select your files to upload');
        }
      },
      handleFileUpload() {
        this.file = this.$refs.csvUpload.files[0];
        this.$store.commit('displaySnackbar', 'File Loaded');
      },

    },
    computed: {
      headers() {
        let headers = [
          {text: 'Name', value: 'name', align: 'center'},
          {text: 'Address', value: 'street1', align: 'center'},
          {text: 'Zone', value: 'zone_name', align: 'center'},
          {text: 'Client', value: 'client_name', align: 'center'},
          {text: 'Invoice No', value: 'invoice', align: 'center'},
          {text: 'Tracking Id', value: 'tracking', align: 'center'},
          {text: 'Status', value: 'status', align: 'center'},
          {text: 'Routing Rule', value: 'routing_rule', align: 'center'},
          {text: 'Service', value: 'service_name', align: 'center'},
          {text: 'Reason Code', value: 'reason_code', align: 'center'},
          {text: 'Route Name', value: 'route_name', align: 'center'},
        ];

        if (this.isInternalUser) {
          headers.unshift({text: 'Client Name', value: 'client_name', align: 'center'});
        }

        return headers;
      },
      regions() {
        return this.$store.getters['auth/permissionRegions']('delivery_view');
      },
      renderedSearch(){
        if (this.Search === null || this.Search === undefined) {
          return [];
        } else {
          return this.Search;
        }
      },
      renderedTimeWindows(){
        if (this.TimeWindows === null || this.TimeWindows === undefined) {
          return [];
        } else {
          return this.TimeWindows;
        }
      },
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      errorTypes() {
        let errorTypes = [
          {
            text: 'Delivered to wrong address',
            value: 'D',
            fault: [
              {text: "Driver", value: 'Driver'},
              {text: "Router", value: 'Router'}
            ]
          },
          {
            text: 'Instructions Not Followed',
            value: 'IN',
            fault: [{text: "Driver", value: 'Driver'}]
          },
          {text: 'Time Window Error',
            value: 'TW',
            fault: [
              {text: "Driver", value: 'Driver'},
              {text: "Linehaul", value: 'Linehaul'},
              {text: "Unknown source", value: 'Unknown'},
            ]
          },
          {
            text: 'Stolen',
            value: 'ST',
            fault: [
              {text: "Unknown source", value: 'Unknown'}
            ]
          },
          {
            text: 'Damaged Box',
            value: 'DT',
            fault: [
              {text: "Driver", value: 'Driver'},
              {text: "Unknown source", value: 'Unknown'}
            ]
          },
          {
            text: 'Driver Behaviour',
            value: 'B',
            fault: [
              {text: "Driver", value: 'Driver'}
            ]
          },
          {
            text: 'Property Damage',
            value: 'P',
            fault: [
              {text: "Driver", value: 'Driver'}
            ]
          },
          {
            text: 'Pick-Pack',
            value: 'PIK',
            fault: [
              {text: "Pick-Pack", value: 'Pick-Pack'}
            ]
          },
        ];
        if (this.isInternalUser) {
          errorTypes.push(
            {
              text: 'Mis sort',
              value: 'MS',
              fault: [
                {text: "Driver", value: 'Driver'},
                {text: "Warehouse", value: 'Warehouse'}
              ]
            },
            {
              text: 'Routing Issue',
              value: 'R',
              fault: [
                {text: "Router", value: 'Router'}
              ]
            },
            {
              text: 'Technical Issue',
              value: 'IT',
              fault: [
                {text: "Router", value: 'Router'},
                {text: "Tech", value: 'Tech'}
              ]
            },
            {
              text: 'No POD / Insufficient POD',
              value: 'PO',
              fault: [
                {text: "Driver", value: 'Driver'},
                {text: "Tech", value: 'Tech'},
              ]
            },
            {
              text: 'General Error',
              value: 'GE',
              fault: [
                {text: "Driver", value: 'Driver'},
                {text: "Warehouse", value: 'Warehouse'},
                {text: "Router", value: 'Router'},
                {text: "Linehaul", value: 'Linehaul'},
                {text: "Tech", value: 'Tech'},
                {text: "Unknown source", value: 'Unknown'},
              ]
            },
            {
              text: 'Unnecessary Returns',
              value: 'UR',
              fault: [
                {text: "Driver", value: 'Driver'},
              ]
            },
          );
        }
        return errorTypes;
      },
      viewPermission() {
        return this.$store.getters['auth/hasPermission']('delivery_admin');
      },
      renderedClients(){
        if (this.clients === null || this.clients === undefined) {
          return [];
        } else {
          return this.clients;
        }
      },

    },
    asyncComputed: {
      async Search(){
        if (this.reload || !this.reload){
          if (this.region && this.date){
            this.loading = true;
            const urlparams = '?region_id='+this.region+'&date='+this.date;

            return await axios.get(process.env.API_URL + '/deliveries/search' + urlparams + this.searchurl)
              .then((response) => {
                this.loading = false;
                this.getSearchFilterList(response.data);
                return response.data;
              })
              .catch((err) => {
                this.$store.commit('displaySnackbar', 'ERROR in search ' + err);
                this.loading = false;
                return [];
              });
          }
        }
      },
      async TimeWindows(){
        if (this.region && this.rescheduleItem.day){
          return await axios.get(process.env.API_URL + '/regions/' + this.region + '/timewindows')
            .then((response) => {
              return response.data.filter( tw => tw.day === this.rescheduleItem.day );
            })
            .catch((err) => {
              this.$store.commit('displaySnackbar', 'ERROR in search ' + err);
              return [];
            });
        }
      },
      async clients() {
        return await axios.get(process.env.API_URL +'/clients')
          .then((response) => {
            if (response.status === 200) {
              return response.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
            } else {
              return [];
            }
          })
          .catch((error) => {
            return [];
          });
      },
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/SearchDeliveryActionPage.vue